import styled from 'styled-components';

const HeaderCellValue = styled.div`
  height: 26px;
  line-height: 26px;
`;

export default HeaderCellValue;
